import _extends from "@babel/runtime/helpers/esm/extends";
import { cleanHtml } from '@magalu/mixer-utils';
export var sellerPageShareGenerator = function sellerPageShareGenerator(_ref) {
  var domain = _ref.domain,
    sellerId = _ref.sellerId,
    sellerName = _ref.sellerName;
  var linkParameters = encodeURIComponent('?partner_id=64853&utm_source=seller_page_desk&utm_medium=share');
  var shareText = encodeURIComponent(cleanHtml("Vem conferir todas as novidades da loja ".concat(sellerName)));
  var shareTitle = encodeURIComponent('O que é bom merece ser compartilhado!');
  var shareUrl = new URL("".concat(domain, "/lojista/").concat(sellerId).concat(linkParameters)).toString();
  var colorObj = {
    color: 'text.white'
  };
  return [_extends({}, colorObj, {
    icon: 'Facebook',
    title: 'facebook',
    url: "https://www.facebook.com/sharer/sharer.php?u=".concat(shareUrl)
  }), _extends({}, colorObj, {
    icon: 'Twitter',
    title: 'twitter',
    url: "https://twitter.com/intent/tweet?text=".concat(shareTitle, "&url=").concat(shareUrl)
  }), _extends({}, colorObj, {
    icon: 'WhatsApp',
    title: 'whatsapp',
    url: "https://wa.me/?text=".concat(shareUrl)
  }), _extends({}, colorObj, {
    icon: 'MailOutline',
    title: 'email',
    url: "mailto:?subject=".concat(shareTitle, "&body=").concat(shareText, "%20").concat(shareUrl)
  })];
};